import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, RouteReuseStrategy } from '@angular/router';

/**
 * The router's normal reuse rule, plus one switch: while `rebuildNext` is true, no route is reused, so a navigation
 * to the SAME url re-creates the page's component (fresh data, nothing remembered inside the old page).
 * PullToRefreshService turns it on for exactly one navigation (the pull-down refresh of a page that has no refresh
 * of its own) and off again right after. With the switch off this behaves exactly like the router's default.
 */
@Injectable({ providedIn: 'root' })
export class PullRefreshRouteReuseStrategy extends BaseRouteReuseStrategy implements RouteReuseStrategy {
  rebuildNext = false;

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return this.rebuildNext ? false : super.shouldReuseRoute(future, curr);
  }
}
